<template>
  <div>
    <!-- 轮播图 -->
    <swiper title="电磁车载巡检系统" :bannerList="bannerList"></swiper>

    <!-- 项目背景 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1" data-aos="fade-up">
      <div class="container">
        <main-title title="项目背景"></main-title>
        <retract-list :dataList="projectList"></retract-list>
      </div>
    </section>

    <!-- 项目介绍 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1" data-aos="fade-up">
      <div class="container">
        <main-title title="项目介绍"></main-title>
        <retract-list :dataList="introduceList"></retract-list>
      </div>
    </section>

    <!-- 产品亮点 -->
    <section class="d-flex align-items-center pt-4 text-line-height-1" data-aos="fade-up">
      <div class="container">
        <main-title title="产品亮点"></main-title>
        <div class="indentation pb-4">
          <desc-list :dataList="lightSpotChartList"></desc-list>
        </div>
        <card-list :dataList="chartList"></card-list>
        <div class="indentation pb-4">
          <desc-list :dataList="lightSpotCityList"></desc-list>
        </div>
        <card-list :dataList="cityList"></card-list>
        <div class="indentation pb-4">
          <desc-list :dataList="lightSpotProgramList"></desc-list>
          <retract-list :dataList="programDataList"></retract-list>
        </div>
        <card-list :dataList="programList"></card-list>
      </div>
    </section>

  </div>
</template>

<script>
import Swiper from '@/components/Swiper.vue'
export default {
  name: 'ElectromagneticVehicle',
  components: { Swiper},
  props: {},
  data() {
    return {
      bannerList: [
        { src: require("@/assets/img/common/caseList/electromagneticVehicle/banner1.png") },
        { src: require("@/assets/img/common/caseList/electromagneticVehicle/banner2.png") },
        { src: require("@/assets/img/common/caseList/electromagneticVehicle/banner3.png") },
      ],
      // 项目背景
      projectList: [
        '为贯彻《中华人民共和国环境保护法》、《中共中央、国务院关于深入打好污染防治攻坚战的意见》加强电磁辐射污染防治，改善电磁环境质量，规范电磁辐射环境监管工作，生态环境部制订了《区域电磁环境质量监测与评估方法（试行）》，并在全国范围内开展区域电磁环境质量监测与评估试点工作。',
        '经过前期调研和资料收集，根据《区域电磁环境质量监测与评估方法（试行）》和相关技术规范编制《湖北省区域电磁环境质量监测与评估试点实施方案》。',
        '项目介绍：通过车载巡测和网格人工测量两种方式开展数据测量并呈现测量效果。',
        '（1）车载巡测在遵守交通规则和确保行车安全的前提下开展巡测：车辆搭载监测设备沿评估区域内向公共开放的快速路、主干路、次干路、支路巡测；测量点位间距不大于 5m；快速路应对双向车道分别巡测；同向多车道巡测时优先选择右侧车道行驶；处于同一位置的立体交通道路（如多层高架道路、下穿隧道等），对可实现卫星定位的各层道路开展巡测。',
        '（2）网格人工测量将评估区域预先划分为多个等大的正方形网格。网格中水面面积或无法监测的区域（如：禁区）面积为 100%或非建成区面积大于 50%的网格为无效网格。整个评估区域的有效网格总数应多 于 100 个。 通过收集区域电磁环境质量基础数据，对十亿级大数据进行自动化数据清洗，汇总成可视化轨迹图、热力图、网格图、柱状图，便于省生态厅直观的监测区域电磁环境质量。'
      ],
      // 项目介绍
      introduceList: [
        '通过收集区域电磁环境质量基础数据，对十亿级大数据进行自动化数据清洗，汇总成可视化轨迹图、热力图、网格图、柱状图，便于省生态厅直观的监测区域电磁环境质量。'
      ],
      // 产品亮点
      lightSpotChartList: [
        {
          title: "高效的数据处理：",
          titleDetail:
            "运用合理的算法对十亿级别的车载巡测数据进行快速处理，汇总成有效数据供系统使用。",
        },
        {
          title: "数据的直观展示：",
          titleDetail:
            "把车载巡测的大数据，通过合理的规则汇集成可视化界面在地图上展示。",
        }
      ],
      // 图类型
      chartList: [
        {
          src: require("@/assets/img/common/electromagneticVehicle/chart/chart1.png"),
          smSrc: require("@/assets/img/common/electromagneticVehicle/chart/chart1-s.png"),
          title: '轨迹图'
        },
        {
          src: require("@/assets/img/common/electromagneticVehicle/chart/chart2.png"),
          smSrc: require("@/assets/img/common/electromagneticVehicle/chart/chart2-s.png"),
          title: '热力图'
        },
        {
          src: require("@/assets/img/common/electromagneticVehicle/chart/chart3.png"),
          smSrc: require("@/assets/img/common/electromagneticVehicle/chart/chart3-s.png"),
          title: '网格图'
        }
      ],
      lightSpotCityList: [
        {
          title: "多城市切换：",
          titleDetail:
            "系统支持武汉、鄂州、荆州城市间切换，提供配置可以无缝接入更多城市数据。",
        }
      ],
      // 城市
      cityList: [
        {
          src: require("@/assets/img/common/electromagneticVehicle/city/city1.png"),
          smSrc: require("@/assets/img/common/electromagneticVehicle/city/city1-s.png"),
          title: '鄂州市'
        },
        {
          src: require("@/assets/img/common/electromagneticVehicle/city/city2.png"),
          smSrc: require("@/assets/img/common/electromagneticVehicle/city/city2-s.png"),
          title: '荆州市'
        }
      ],
      lightSpotProgramList: [
        {
          title: "高自由度的地图自定义交互：",
          titleDetail: "",
        }
      ],
      programDataList: [
        '1、可地图区域中选取矩形、圆形、多边形，并根据选取的图形区域展示当前区域电场强度占标率、区域积分场强等数据。',
        '2、选取的图形区域展示的当前区域电场强度占标率、区域积分场强数据可与不同来源数据进行比对并展示。',
        '3、根据对角线的起点终点、角度绘制可设置数量的多边形框。',
        '4、多边形的大小要求可以自定义设置。'
      ],
      // 方案
      programList: [
        {
          src: require("@/assets/img/common/electromagneticVehicle/program/program1.png"),
          smSrc: require("@/assets/img/common/electromagneticVehicle/program/program1-s.png"),
          title: '方案一：500m*500m'
        },
        {
          src: require("@/assets/img/common/electromagneticVehicle/program/program2.png"),
          smSrc: require("@/assets/img/common/electromagneticVehicle/program/program2-s.png"),
          title: '方案二：1000m*1000m'
        }
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {

  },
  created() {

  },
  mounted() {

  },
}
</script>
<style scoped>
</style>